import React, { useState, useRef, useEffect } from "react";
import { Button, Form, Container, Stack } from "react-bootstrap";

const styles = {
  container: {
    maxWidth: "100%",
  },
  comentarioBox: {
    backgroundColor: "var(--color-background)",
    whiteSpace: "pre-wrap",
    overflowWrap: "anywhere",
    wordWrap: "break-word",
    maxWidth: "100%",
    minWidth: 0,
  },
};

function ComentarioEditable({ atencion, onSave }) {
  const [isEditing, setIsEditing] = useState(false);
  const [edited, setEdited] = useState(atencion.comentario || "");
  const textareaRef = useRef(null);

  useEffect(() => {
    if (isEditing && textareaRef.current) {
      const el = textareaRef.current;
      el.focus();
      el.selectionStart = el.selectionEnd = el.value.length;
    }
  }, [isEditing]);

  const cancel = () => {
    setIsEditing(false);
    setEdited(atencion.comentario || "");
  };

  const save = async () => {
    await onSave(edited, atencion.id);
    setIsEditing(false);
  };

  return (
    <>
      {!isEditing ? (
        <Container className="p-0 d-flex justify-content-between align-items-start">
          {edited && edited.trim() !== "" ? (
            <div
              className="flex-grow-1 border rounded p-2"
              style={styles.comentarioBox}
            >
              {edited}
            </div>
          ) : (
            <p className="m-0 text-muted"> Sin comentarios</p>
          )}
          {atencion.editable && (
            <button
              className="ms-2"
              style={{
                background: "none",
                border: "none",
                color: "var(--color-text-muted)",
                cursor: "pointer",
              }}
              title="Editar comentario"
              onClick={() => setIsEditing(true)}
            >
              <i className="bi bi-pencil-square fs-5"></i>
            </button>
          )}
        </Container>
      ) : (
        <Container style={styles.container} className="p-0">
          <Form.Control
            as="textarea"
            rows={3}
            ref={textareaRef}
            value={edited}
            onChange={(e) => setEdited(e.target.value)}
          />

          <div className="d-flex justify-content-end gap-2 mt-2">
            <Button size="sm" variant="secondary" onClick={cancel}>
              Cancelar
            </Button>
            <Button size="sm" className="btn-accent" onClick={save}>
              Guardar
            </Button>
          </div>
        </Container>
      )}
    </>
  );
}

export default ComentarioEditable;
